import React, { Component } from "react";
import { connect } from "react-redux";
import { View, ScrollView } from "react-native";
import Text from "../../components_v2/TextFont";
import { ArButton } from "../../argon-ui";
import Theme from "../../argon-ui/Theme";

import { translate } from "../../locales/translate";

import SearchableDropdown from "../SearchableDropDown";
import * as AreaHelper from "../../actions/AreaHelper";
import { ScenarioDeviceEventCondition } from "../../viewModels/Scenario";
import Switch from "../../components/ToggleSwitch";
import { faEdit } from "../../../assets/consts/faCharCodes";
import InputBase from "../../nativeBase-ui/InputBase";
import ConditionEventLayout from "./ConditionEventLayout";
import TabBase from "../../nativeBase-ui/TabBase";

class MainConditionDeviceEventGenerator extends Component {
  constructor(props) {
    super(props);

    this.state = {
      selectedGroup: "",
      selectedDeviceId: 0,
      selectedDeviceName: "",
      selectedEvent: "",
      searchedDeviceName: "",

      areaId: this.props.areaId || 0,
      areaUId: this.props.areaUId || null,
      areaName: this.props.areaName || "",
      errorMessage: "",

      listener: "",
      event: "",
      deviceId: undefined,
      deviceUId: undefined,
      deviceName: "",
      deviceType: "",
      parameterTypes: [],
      parameterValues: [],
      parameterNames: [],
      tab: "batch", // batch | single
    };
    this.allTypes = [];
    this.allTypesDropdown = [];

    this.deviceDropdownList = [];

    this.eventsListDropdown = [];
    this.listeners = [];

    this.listenerSingleEvents = [];
    this.listenerBatchEvents = [];

    this.listenerSensors = [];
    this.tabs = ["single", "batch"];
  }

  componentDidMount() {
    this.props.deviceReducer.list.map((d, i) => {
      if (this.allTypes.indexOf(d.deviceType) < 0) {
        this.allTypes.push(d.deviceType);
        this.allTypesDropdown.push({
          id: d.deviceType,
          name: translate(`deviceGroup.${d.deviceType}`),
        });
      }
    });

    this.props.areaReducer.eventListeners.map((l, i) => {
      this.listeners.push({
        id: l.listener,
        name: translate(`scenario.${l.listener}`),
      });
    });
  }

  onListenerSelect = (listener) => {
    var listenerModel = this.findListenerByName(listener);

    for (var i in listenerModel.events) {
      var item = {
        id: listenerModel.events[i].event,
        name: translate(`scenario.${listenerModel.events[i].event}`),
      };
      if (listenerModel.events[i].isBatchEvent) {
        this.listenerBatchEvents.push(item);
      } else {
        this.listenerSingleEvents.push(item);
      }
    }

    // reset devices dropdown
    this.listenerSensors = [];
    var area = AreaHelper.findAreaById(
      this.props.areaReducer.areas,
      this.state.areaId || this.state.areaUId
    );
    if (area && Array.isArray(area.devices) && area.devices.length) {
      let allDevices = this.props.deviceReducer.list;
      const _areaDevices = area.devices ? area.devices : area.uDevices;
      for (var i in _areaDevices) {
        for (var j in allDevices) {
          const _devices = _areaDevices[i];
          if (
            (_devices == allDevices[j].deviceId ||
              _devices == allDevices[j].deviceUId) &&
            !allDevices[j].statusRelayId && // has no status relay (for air-conditioners only)
            listenerModel.deviceType
              .split(",")
              .indexOf(allDevices[j].deviceType) >= 0
          ) {
            this.listenerSensors.push({
              id: allDevices[j].deviceId || allDevices[j].deviceUId,
              name: allDevices[j].deviceName,
            });
          }
        }
      }
    }

    // set manager name and clear action with its parameters.
    this.setState({
      listener,
      event: "",
      parameterTypes: [],
      parameterValues: [],
      parameterNames: [],
    });
  };

  onListenerClear = () => {
    this.onEventClear();
    this.listenerBatchEvents = [];
    this.listenerSingleEvents = [];
    this.listenerSensors = [];
    this.setState({
      listener: "",
      event: "",
      parameterTypes: [],
      parameterValues: [],
      parameterNames: [],
    });
  };

  onEventSelect = (event) => {
    var listenerModel = this.findListenerByName(this.state.listener);
    var _paramTypes = [],
      _paramNames = [],
      _paramValues = [];
    if (
      listenerModel &&
      listenerModel.events &&
      listenerModel.events.length > 0
    ) {
      for (var i in listenerModel.events) {
        if (listenerModel.events[i].event == event) {
          var eventModel = listenerModel.events[i];

          if (eventModel.argTypes && eventModel.argTypes.length) {
            for (var j in eventModel.argTypes) {
              _paramNames.push(eventModel.argNames[j]);
              var pt = eventModel.argTypes[j].toLowerCase();
              _paramTypes.push(pt);
              switch (pt) {
                case "bool":
                  _paramValues.push(false); //default for boolean (like toggles,...)
                  break;
                case "int":
                case "int32":
                case "short":
                  _paramValues.push(0); //default for numbers
                  break;
                case "byte":
                  _paramValues.push(128); //default for sliders (like dimmer lights,...) 128 in bytes equals 50%
                  break;
                default: //default for unknown
                  _paramValues.push("");
                  break;
              }
            }
            break;
          }
        }
      }
    }
    this.setState({
      event,
      deviceType: listenerModel.deviceType,
      parameterTypes: _paramTypes,
      parameterValues: _paramValues,
      parameterNames: _paramNames,
    });
  };

  onEventClear = () => {
    this.setState({
      event: "",
      parameterTypes: [],
      parameterValues: [],
      parameterNames: [],
    });
  };

  findListenerByName = (listenerName) => {
    let { eventListeners } = this.props.areaReducer;
    for (var i in eventListeners) {
      if (eventListeners[i].listener == listenerName) {
        return eventListeners[i];
      }
    }
  };

  handleOnConfirm = () => {
    if (typeof this.props.onConfirm != "function") {
      return;
    }

    var listenerModel = {};
    var eventModel = {};

    listenerModel = this.findListenerByName(this.state.listener);

    for (var j in listenerModel.events) {
      if (listenerModel.events[j].event == this.state.event) {
        eventModel = listenerModel.events[j];
        break;
      }
    }
    // ===  find devices selected by deviceId or deviceUId ===
    const _devices = this.props.deviceReducer.list.find(
      (device) =>
        device.deviceId == this.state.deviceId ||
        device.deviceUId == this.state.deviceId
    );
    var result = new ScenarioDeviceEventCondition();
    result.deviceId = _devices?.deviceId;
    result.deviceUId = _devices?.deviceUId;
    result.deviceName = this.state.deviceName;
    result.deviceType = this.state.deviceType;
    result.listenerName = this.state.listener;
    result.eventName = this.state.event;
    result.areaId = this.state.areaId;
    result.areaUId = this.state.areaUId;
    result.areaName = this.state.areaName;
    result.parameterNames = this.state.parameterNames;
    result.parameterValues = this.state.parameterValues;
    result.parameterTypes = this.state.parameterTypes;
    this.props.onConfirm(result);
  };

  handleTabChange = (tab) => {
    this.setState(
      {
        tab,
        event: "",
        deviceId: undefined,
        deviceUId: undefined,
        parameterTypes: [],
        parameterValues: [],
        parameterNames: [],
      },
      () => {}
    );
  };

  renderParametersSection = () => {
    let { parameterNames, parameterTypes, parameterValues } = this.state;
    if (
      parameterNames.length > 0 &&
      parameterNames.length == parameterTypes.length &&
      parameterNames.length == parameterValues.length
    ) {
      return (
        <ScrollView>
          {parameterTypes.map((pt, i) => {
            var pn = parameterNames[i];
            if (pt == "bool" || pt == "boolean") {
              return (
                <View key={i} style={{ flexDirection: "row" }}>
                  <Text style={{ flex: 1 }}>
                    {translate(`scenario.${this.state.parameterNames[i]}`)}
                  </Text>
                  <Switch
                    isOn={this.state.parameterValues[i]}
                    onColor={Theme.COLORS.ACTIVE}
                    offColor={Theme.COLORS.MUTED}
                    size="small"
                    onToggle={(v) => {
                      var pv = this.state.parameterValues;
                      pv[i] = v;
                      this.setState({ parameterValues: pv });
                    }}
                    animationSpeed={0}
                  />
                </View>
              );
            } else if (pt == "byte") {
              return null;
              {
                /* return (
                <DeviceDimmer
                  key={i}
                  style={{ paddingHorizontal: 10 }}
                  startIcon={faChevronCircleDown}
                  endIcon={faChevronCircleUp}
                  currentValue={this.state.parameterValues[i] || 0}
                  hasToggle={false}
                  onValueChange={(v) => {
                    var _ps = [...this.state.parameterValues];
                    _ps[i] = v;
                    this.setState({ parameterValues: _ps });
                  }}
                />
              ); */
              }
            } else if (pt == "int" || pt == "int32" || pt == "short")
              return (
                <InputBase
                  key={i}
                  keyboardType="numeric"
                  label={translate(`scenario.${this.state.parameterNames[i]}`)}
                  onChangeText={(txt) => {
                    var _ps = [...this.state.parameterValues];
                    _ps[i] = Number(txt) || 0;
                    this.setState({ parameterValues: _ps });
                  }}
                  value={parameterValues[i].toString()}
                  icon={faEdit}
                />
              );
            else
              return (
                <InputBase
                  key={i}
                  label={translate(`scenario.${this.state.parameterNames[i]}`)}
                  placeholder=""
                  value={parameterValues[i].toString()}
                  onChangeText={(txt) => {
                    var _ps = [...this.state.parameterValues];
                    _ps[i] = txt;
                    this.setState({ parameterValues: _ps });
                  }}
                  icon={faEdit}
                />
              );
          })}
        </ScrollView>
      );
    }

    return null;
  };

  render() {
    return (
      <ScrollView
        contentContainerStyle={{ flex: 1 }}
        style={
          this.props.style || {
            flex: 1,
            paddingTop: 10,
          }
        }
      >
        <View style={{ flex: 1, height: "100%" }}>
          <ConditionEventLayout
            title={translate("scenario.deviceEvent")}
            subTitle={
              translate("scenario.deviceEventsOfArea") +
              `"${this.state.areaName}"`
            }
          >
            {/* listeners dropdown */}
            <SearchableDropdown
              label={translate("device.deviceType")}
              items={this.listeners}
              clearable={true}
              onSelect={this.onListenerSelect}
              onClear={this.onListenerClear}
              style={{ width: "100%", alignSelf: "center" }}
            />
            {/* tabs */}
            <TabBase
              containerStyle={{ marginVertical: 10 }}
              tabs={this.tabs}
              tab={this.state.tab}
              handleChange={(tab) => this.handleTabChange(tab)}
            >
              {/* batch form */}
              {this.state.tab == "batch" && (
                <View>
                  <SearchableDropdown
                    clearable={true}
                    label={translate("scenario.events")}
                    noItemText={translate("scenario.pickCategoryFirst")}
                    items={this.listenerBatchEvents}
                    onSelect={this.onEventSelect}
                    onClear={this.onEventClear}
                  />
                  {this.renderParametersSection()}
                </View>
              )}
              {/* single form */}
              {this.state.tab == "single" && (
                <View>
                  <SearchableDropdown
                    clearable={true}
                    label={translate("scenario.sensors")}
                    noItemText={
                      !this.state.listener
                        ? translate("scenario.pickCategoryFirst")
                        : undefined
                    }
                    items={this.listenerSensors}
                    onSelect={(deviceId, deviceName) =>
                      this.setState({ deviceId, deviceName })
                    }
                    onClear={() =>
                      this.setState({
                        deviceId: undefined,
                        deviceUId: undefined,
                        deviceName: undefined,
                      })
                    }
                  />
                  <SearchableDropdown
                    clearable={true}
                    label={translate("scenario.events")}
                    items={
                      this.state.deviceId
                        ? this.listenerSingleEvents
                        : undefined
                    }
                    noItemText={
                      !this.state.listener
                        ? translate("scenario.pickCategoryFirst")
                        : !this.state.deviceId
                        ? translate("scenario.pickDeviceFirst")
                        : "---"
                    }
                    onSelect={this.onEventSelect}
                    onClear={this.onEventClear}
                  />
                  {this.renderParametersSection()}
                </View>
              )}
            </TabBase>
            {/* condition Error */}
            <Text
              style={{
                color: Theme.COLORS.ERROR,
                alignSelf: "center",
                paddingTop: 20,
              }}
            >
              {this.state.errorMessage}
            </Text>
          </ConditionEventLayout>
          {/* continue button */}
          <ArButton
            color="primary"
            style={{ width: "100%", alignSelf: "center" }}
            onPress={this.handleOnConfirm}
          >
            <Text style={{ color: "#FFF" }}>{translate("app.continue")}</Text>
          </ArButton>
        </View>
      </ScrollView>
    );
  }
}

const mapStateToProps = (state) => {
  return { deviceReducer: state.DeviceReducer, areaReducer: state.AreaReducer };
};

const mapDispatchToProps = (dispatch) => {
  return {};
};

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(MainConditionDeviceEventGenerator);
